import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';
import * as Mixins from "../mixins"

const StyledContestRow = styled.div`
  &.contest_row_container--winner {
    display: none;
    &.active {
      display: block;
    }
  }
  .hover_container {
    position: relative;
  }
  .hover_entry {
    z-index: 2;
    position: absolute;
    font-family: Open Sans, sans-serif;
    line-height: 1.2;
    font-size: 12px;
    color: ${Mixins.palette.white};
    padding: 0.5rem;
    width: 152px;
    background: #272727;
    opacity: 0;
    transition: opacity 400ms;
    transition-delay: 300ms;
    ${Mixins.mq("tablet")} {
      right: 0;
    }
  }
  .hover_icon {
    display: block;
    font-size: 1rem;
    color: ${Mixins.palette.white};
    border: 0;
    background: 0;
    z-index: 2;
    &:hover,
    &:active,
    &:focus {
      & + .hover_entry {
        opacity: 1;
        transition: opacity 100ms;
        transition-delay: 0ms;
      }
    }
  }
`;

const ContestRow = ({ data, activeFilter }) => {
  const buildContestRow = (contestRowData) => {
    return (
      <>
        <div className="contest_row__item contest_row__item--date">{contestRowData.date}</div>
        <div className="contest_row__item contest_row__item--event">{contestRowData.event_name}</div>
        <div className="contest_row__item contest_row__item--entry contest_row__item--hide_in_desktop">{contestRowData.entry_fee} | {contestRowData.top_prize}</div>
        <div className="contest_row__item contest_row__item--entry contest_row__item--hide_in_mobile">
          {contestRowData.entry_fee}
        </div>
        <div className="contest_row__item contest_row__item--prize contest_row__item--hide_in_mobile">{contestRowData.top_prize}</div>
        <div className="contest_row__item contest_row__item--link">
          <a href={contestRowData.event_link.href}>{contestRowData.event_link.title} </a>
        </div>
      </>
    );
  };
return (
    <StyledContestRow className="contest_row_container contest_row_container--color_scheme">
    <div className={cx('contest_row')}>{buildContestRow(data)}</div>
    </StyledContestRow>
);
};

export default ContestRow;
